import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { IonicPageModule, IonicModule } from 'ionic-angular';
import { CoEventFinderPage } from './co-event-finder';
import { PipesModule } from '../../pipes/pipes.module';
import { ComponentsModule } from '../../components/components.module';
import { DirectivesModule } from '../../directives/directives.module';
import { BrowserModule } from '@angular/platform-browser';
import { InfiniteListModule } from 'angular-infinite-list';
import { PopoverModule } from 'ng4-popover';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { DpDatePickerModule } from 'ng2-date-picker';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { CoSelfcheckAccountPageModule } from '../co-selfcheck-account/co-selfcheck-account.module';

@NgModule({
  declarations: [
    CoEventFinderPage,
  ],
  imports: [
    IonicPageModule.forChild(CoEventFinderPage),
    PipesModule,
    ComponentsModule,
    DirectivesModule,
    BrowserModule,
    InfiniteListModule,
    IonicModule,
    PopoverModule,
    VirtualScrollerModule,
    DpDatePickerModule,
    MyDateRangePickerModule,
    CoSelfcheckAccountPageModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class CoEventFinderPageModule {}



// WEBPACK FOOTER //
// ./src/pages/co-event-finder/co-event-finder.module.ts